import { defineMessages } from "react-intl";

export const accessLogMessages = defineMessages({
  sectionName: {
    id: "RSOCIR",
    defaultMessage: "Access log",
    description: "section name",
  },
  menuDescription: {
    id: "ib+aW+",
    defaultMessage: "See who signed in, when and from where (admins only)",
    description: "configuration menu item description",
  },
  description: {
    id: "GQJurz",
    defaultMessage:
      "Every sign-in attempt on the dashboard and the ops app, both steps: the email code asked before the page opens and the password sign-in. Who, when, from which IP and device, and whether it worked. Newest first. The country comes from Cloudflare and is only indicative.",
    description: "page description",
  },
  search: {
    id: "uexBU4",
    defaultMessage: "Search by email or IP",
    description: "input label",
  },
  outcomeFilter: {
    id: "rDHjup",
    defaultMessage: "Result",
    description: "filter label",
  },
  platformFilter: {
    id: "ppmFfW",
    defaultMessage: "Platform",
    description: "filter label",
  },
  all: {
    id: "N5Mz06",
    defaultMessage: "All",
    description: "filter option: no filter",
  },
  columnWhen: {
    id: "XvGUin",
    defaultMessage: "When",
    description: "column title",
  },
  columnWho: {
    id: "jmvXFu",
    defaultMessage: "Who",
    description: "column title",
  },
  columnResult: {
    id: "aH04Na",
    defaultMessage: "Result",
    description: "column title",
  },
  columnPlatform: {
    id: "WCySAB",
    defaultMessage: "Platform",
    description: "column title",
  },
  columnFrom: {
    id: "u+psjo",
    defaultMessage: "From",
    description: "column title: IP address and country",
  },
  columnDevice: {
    id: "ZdXP7i",
    defaultMessage: "Device",
    description: "column title",
  },
  success: {
    id: "tbQViV",
    defaultMessage: "Signed in",
    description: "sign-in result",
  },
  invalidCredentials: {
    id: "uEOUMD",
    defaultMessage: "Wrong password",
    description: "sign-in result",
  },
  throttled: {
    id: "9m0kTm",
    defaultMessage: "Blocked (too many attempts)",
    description: "sign-in result",
  },
  accountBlocked: {
    id: "BMurQB",
    defaultMessage: "Account inactive",
    description: "sign-in result",
  },
  platformDenied: {
    id: "pMtNMX",
    defaultMessage: "No access to platform",
    description: "sign-in result",
  },
  unknownAccount: {
    id: "26tuD3",
    defaultMessage: "Unknown account",
    description: "typed email does not match any account",
  },
  empty: {
    id: "2M2npL",
    defaultMessage: "No sign-in attempts recorded yet",
    description: "empty state",
  },
  loadMore: {
    id: "oIS3NK",
    defaultMessage: "Show more",
    description: "button",
  },
  columnLastLogin: {
    id: "lvhIYf",
    defaultMessage: "Last sign-in",
    description: "staff list column title",
  },
  neverSignedIn: {
    id: "RZYxvb",
    defaultMessage: "Never",
    description: "staff member has not signed in yet",
  },
  outsideHours: {
    id: "dez1+2",
    defaultMessage: "Refused: outside opening hours",
    description: "sign-in result",
  },
  ipBlocked: {
    id: "S2MRAk",
    defaultMessage: "Refused: network not allowed",
    description: "sign-in result",
  },
  tabSignIns: {
    id: "nSYtOO",
    defaultMessage: "Sign-ins",
    description: "tab title",
  },
  tabActivity: {
    id: "MEmNiM",
    defaultMessage: "Activity",
    description: "tab title",
  },
  activityDescription: {
    id: "kqUuXJ",
    defaultMessage:
      "What signed-in staff did: every change they made, on which item, whether it worked, and from where. Values they typed are never stored. Newest first.",
    description: "page description for the activity tab",
  },
  timeZoneNote: {
    id: "mTUmez",
    defaultMessage: "Times are shown in {timeZone}.",
    description: "note under the page description",
  },
  columnAction: {
    id: "YK6VBI",
    defaultMessage: "Action",
    description: "column title",
  },
  columnItems: {
    id: "n8dPtn",
    defaultMessage: "Items",
    description: "column title: objects the action was applied to",
  },
  columnDetail: {
    id: "YW5KMi",
    defaultMessage: "Detail",
    description: "column title",
  },
  succeeded: {
    id: "/UxT4G",
    defaultMessage: "Done",
    description: "activity result",
  },
  failed: {
    id: "/ACssI",
    defaultMessage: "Failed",
    description: "activity result",
  },
  resultFilterAll: {
    id: "0UMXoV",
    defaultMessage: "Any result",
    description: "activity result filter option",
  },
  searchActivity: {
    id: "qqVIvx",
    defaultMessage: "Search by email, action or detail",
    description: "input label",
  },
  adminOnly: {
    id: "HpVUc0",
    defaultMessage: "Only admins can see the access log.",
    description: "shown to non-admins who open the access log",
  },
  refresh: {
    id: "XCIV8H",
    defaultMessage: "Refresh",
    description: "button",
  },
  codeSent: {
    id: "6cWDlM",
    defaultMessage: "Code emailed",
    description: "sign-in result: dashboard gate sent an access code",
  },
  wrongCode: {
    id: "ufwhSs",
    defaultMessage: "Wrong code",
    description: "sign-in result: dashboard gate code was wrong",
  },
  codeExpired: {
    id: "+lZWHg",
    defaultMessage: "Code expired or used up",
    description: "sign-in result: dashboard gate code no longer valid",
  },
  notStaff: {
    id: "TDvBQM",
    defaultMessage: "Not a staff email",
    description: "sign-in result: dashboard gate code requested for a non-staff email",
  },
  methodFilter: {
    id: "Qzsfjk",
    defaultMessage: "Method",
    description: "filter label: how the sign-in authenticated",
  },
  columnMethod: {
    id: "UQEGaV",
    defaultMessage: "Method",
    description: "column title: how the sign-in authenticated",
  },
  methodPassword: {
    id: "zhlam0",
    defaultMessage: "Password",
    description: "sign-in method: dashboard sign-in form",
  },
  methodEmailCode: {
    id: "JFHRzP",
    defaultMessage: "Email code",
    description: "sign-in method: one-time code from the dashboard gate",
  },
});
